export function findObjectByKeySetError(array, key, value, errorMessage) {
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      array[i].supportMessage = errorMessage;
    }
  }
  return null;
}
